<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="openAddForm"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Leave request
    </button>

    <!-- Modal -->
    <a-modal v-model="visible" title="Add or Update Student Leave Request" onOk="handleOk"
      :width="this.settings['isMobileView'] ? 480 : 720"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSave">Save Leave request</a-button>
      </template>
      <a-spin :spinning="spinning">
        <template v-if="!studentLeaveRequestId">
          <div class="mb-2">
            <p class="text-primary mb-0">Select a session, class and section to select student to add Leave request.</p>
          </div>
          <!-- Select Student -->
          <div class="row align-items-center mb-2">
            <!-- Session Select -->
            <div class="col-md-4 col-12 mb-2">
              <a-spin :spinning="sessionSpinning">
                <a-select
                  size="default"
                  v-model="selectedSession"
                  optionFilterProp="children"
                  style="width: 100%"
                  @change="handleSessionChange"
                  :filterOption="false"
                  :defaultValue="currentSession ? currentSession.id : ''"
                >
                <template v-for="schoolSession in schoolSessions">
                  <a-select-option :value="schoolSession.id" :key="schoolSession.id">
                      {{schoolSession.name}}
                      <small class="text-primary ml-2">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
                  </a-select-option>
                </template>
                </a-select>
              </a-spin>
            </div>
            <!-- Class Select -->
            <div class="col-md-4 col-12 mb-2">
              <a-spin :spinning="classSpinning">
                <a-select
                  size="default"
                  v-model="selectedClass"
                  placeholder="Select class"
                  optionFilterProp="children"
                  style="width: 100%"
                  @change="handleClassSelect"
                  :filterOption="false"
                  :defaultValue="undefined"
                >
                  <a-select-option :value="undefined">Select class</a-select-option>
                  <template v-for="schoolClass in schoolClasses">
                    <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                    {{schoolClass.name}}
                    </a-select-option>
                  </template>
                </a-select>
              </a-spin>
            </div>
            <!-- Section Select -->
            <div class="col-md-4 col-12 mb-2">
              <a-spin :spinning="sectionSpinning">
                <a-select
                size="default"
                  v-model="selectedSection"
                  placeholder="Select section"
                  optionFilterProp="children"
                  style="width: 100%"
                  @change="handleSectionChange"
                  :filterOption="false"
                  :defaultValue="undefined"
                  :disabled="!selectedClass"
                >
                  <a-select-option :value="undefined">Select section</a-select-option>
                  <template v-for="section in sections">
                    <a-select-option :value="section.id" :key="section.id">
                    {{section.name}}
                    </a-select-option>
                  </template>
                </a-select>
              </a-spin>
            </div>
            <div class="col-md-12 col-12 mb-2">
                <div class="text-right">
                  <a-input-search
                    placeholder="Search Students.."
                    size="large"
                    v-model="search"
                    @search="searchStudents"
                    @change="searchStudents"
                    :disabled="!selectedSection"
                  />
                </div>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-md-12">
              <div class="bg-light p-4 rounded" style="max-height:150px; overflow:hidden; overflow-y:auto;">
                <a-spin :spinning="studentSpinning">
                  <div class="row" v-if="data.length">
                    <div class="col-12 col-md-6" v-for="student in data" :key="student.id">
                      <div
                        style="cursor:pointer;"
                        :class="['rounded border mb-2 p-1', isStudentSelected(student) ? 'bg-primary text-white' : '']"
                        @click="handleStudentSelect(student)"
                      >
                        ({{student.student_code}}) <span class="font-weight-bold">{{student.first_name}} {{student.last_name}}</span> ({{student.enrollment[0].school_class.name}}-{{student.enrollment[0].section.name}}-{{student.enrollment[0].roll_no}})
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <p>Select class and section to view students</p>
                  </div>
                </a-spin>
              </div>
              <div v-if="data.length" class="mt-2 text-right">
                <a-pagination
                    showSizeChanger
                    @showSizeChange="onShowSizeChange"
                    :total="meta.total"
                    :pageSize.sync="pageSize"
                    v-model="current"
                    @change="onChange"
                  >
                </a-pagination>
              </div>
            </div>
          </div>
        </template>

        <!-- Select Teacher -->
        <div class="row align-items-center mb-2">
          <div class="col-md-12 col-12 mb-2">
              <div class="text-right">
                <a-input-search
                  placeholder="Search Teacher.."
                  size="large"
                  v-model="teacherSearch"
                  @search="searchTeachers"
                  @change="searchTeachers"
                  :disabled="!teachers.length"
                />
              </div>
          </div>
        </div>

        <div class="row mb-4">
          <div class="col-md-12">
            <div class="bg-light p-4 rounded" style="max-height:150px; overflow:hidden; overflow-y:auto;">
              <a-spin :spinning="teacherSpinning">
                <div class="row" v-if="teachers.length">
                  <div class="col-12 col-md-6" v-for="teacher in teachers" :key="teacher.id">
                    <div
                      style="cursor:pointer;"
                      :class="['d-flex rounded border mb-2 p-1', isTeacherSelected(teacher) ? 'bg-primary text-white' : '']"
                      @click="handleTeacherSelect(teacher)"
                    >
                      <a-avatar
                        slot="avatar"
                        :src="`${teacher.photo}`"
                      />
                      <div class="ml-3">
                        <p class="font-weight-bold mb-0">{{teacher.first_name}} {{teacher.last_name}}</p>
                        <p class="text-sm mb-0">{{teacher.title}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <p>No teachers found..</p>
                </div>
              </a-spin>
            </div>
            <div v-if="teachers.length" class="mt-2 text-right">
              <a-pagination
                  showSizeChanger
                  @showSizeChange="onShowTeachersSizeChange"
                  :total="teachersMeta.total"
                  :pageSize.sync="teacherPageSize"
                  v-model="teacherCurrent"
                  @change="teacherOnChange"
                >
              </a-pagination>
            </div>
          </div>
        </div>

        <a-divider />

        <div class="row mt-4">
          <div class="col-md-6 d-flex align-items-center">
            <div class="font-weight-bold mr-4">Student(s) :</div>
            <div class="col-8 border rounded p-2">
              <div v-for="(enrollment, index) in enrollments" :key="index" >
                <div class="font-weight-bold">{{enrollment.student.first_name}} {{enrollment.student.last_name }}</div>
                <div>({{enrollment.student_code}} | {{enrollment.school_class.name}}-{{enrollment.section.name}}-{{enrollment.roll_no}})</div>
              </div>
            </div>
          </div>
          <div class="col-md-6 d-flex align-items-center">
            <div class="font-weight-bold mr-4">Assigned to :</div>
            <div class="col-8 border rounded p-2">
              <div v-if="selectedTeacher">
                <span class="font-weight-bold">{{selectedTeacher.first_name}} {{selectedTeacher.last_name}} ({{selectedTeacher.staff_id}})</span>
              </div>
              <span v-else>No teacher selected</span>
            </div>
          </div>
        </div>

        <!-- Form -->
        <a-form class="row my-4" :form="form">
          <a-form-item label="Leave Type" class="col-sm-6">
            <a-select :disabled="true" style="color: #000000"
              v-decorator="['leave_type', {rules: [{ required: true, message: 'Please select a leave type' }], initialValue: 'Sick'},]"
            >
              <a-select-option v-for="leavetype in leavetypes" :value="leavetype.value" :key="leavetype.value">
                <span class="text-bold" :style="`font-family:${leavetype.value}`">
                  {{leavetype.name}}
                </span>
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Duration" class="col-sm-6">
            <a-select :disabled="true" style="color: #000000 "
              v-decorator="['duration', {rules: [{ required: true, message: 'Please select duration' }], initialValue: 'Full Day'},]"
            >
              <a-select-option v-for="duration in leavedurations" :value="duration.value" :key="duration.value">
                <span class="text-bold" :style="`font-family:${duration.value}`">
                  {{duration.name}}
                </span>
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Start Date" class="col-sm-6">
            <a-date-picker style="color: #000000 !important;"
              v-decorator="[
              'start_date',
              {rules: [{ required: true, message: 'Please input a start date' }], initialValue: moment()},
              ]"
              :format=dateFormat
              :disabled="true"
            />
          </a-form-item>
          <a-form-item label="End Date" class="col-sm-6">
            <a-date-picker style="color: #000000 !important;"
              v-decorator="[
              'end_date',
              {rules: [{ required: true, message: 'Please input an end date' }], initialValue: moment()},
              ]"
              :format=dateFormat
              :disabled="true"
            />
          </a-form-item>
          <a-form-item label="Reason" class="col-sm-12">
            <a-textarea style="color: #000000" placeholder="Reason" :autosize="{minRows: 2}" :disabled="true" v-decorator="['reason', {rules: [{required:true, max: 500, message: 'Must not exceed 100 characters!'}]}]" />
          </a-form-item>
          <a-form-item label="Status" class="col-sm-6">
            <a-select
              v-decorator="['status', {rules: [{ required: true, message: 'Please select a status' }], initialValue: 'Pending'},]"
            >
              <a-select-option v-for="status in statuses" :value="status.value" :key="status.value">
                <span class="text-bold" :style="`font-family:${status.value}`">
                  {{status.name}}
                </span>
              </a-select-option>
            </a-select>
          </a-form-item>
<!--          <a-form-item label="Teacher Remark" class="col-sm-12">
            <a-textarea placeholder="Teacher Remark" :autosize="{minRows: 2}" v-decorator="['teacher_remark', {rules: [{max: 500, message: 'Must not exceed 100 characters!'}]}]" />
          </a-form-item>-->
          <div class="col-sm-12 mt-4">
            <strong>Attachments ({{leaveRequestFiles.length}}): </strong>
            <div v-for="(leaveReqFile, index) in leaveRequestFiles" :key="index"  >
              <a :href="leaveReqFile.file" target="_blank"><span class="fa fa-download"></span> {{leaveReqFile.file.split('/').pop()}}</a>
            </div>
          </div>
          <leave-request-comments class="col-sm-12 mt-4" :dataFromParent="comments"></leave-request-comments>
          <a-form-item class="col-sm-12">
            <a-textarea
              placeholder="Approver comments..."
              v-decorator="['comment',]"
            />
          </a-form-item>
          <a-form-item class="col-sm-6">
            <a-upload v-decorator="['file', { rules: [{ required: false, message: 'Please input a file.' }] }]"
                      accept=".jpg,.jpeg,.png,.pdf,.xls,.xlsx,.doc,.docx, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      :fileList="fileList" :multiple="true" :remove="handleRemove" :beforeUpload="beforeUpload"
                      :disabled="uploadDisabled">
              <button type="button" class="btn btn-dark btn-with-addon">
                <span class="btn-addon">
                  <i class="btn-addon-icon fe fe-file-text" />
                </span>
                Attach File
              </button>
            </a-upload>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import pick from 'lodash/pick'
import moment from 'moment'
import { debounce, find } from 'lodash'
import { mapState } from 'vuex'
import LeaveRequestComments from './comments'

import { statuses, leavetypes, leavedurations } from '../data'

export default {
  name: 'LeaveRequestForm',
  components: { LeaveRequestComments },
  data: function() {
    return {
      form: this.$form.createForm(this),
      statuses,
      leavetypes,
      leavedurations,
      data: [],
      meta: {},
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      teachers: [],
      teachersMeta: {},
      current: 1,
      pageSize: 10,
      teacherCurrent: 1,
      teacherPageSize: 10,
      selectedClass: undefined,
      selectedSection: undefined,
      selectedSession: undefined,
      selectedStudent: null,
      selectedTeacher: null,
      sessionSpinning: false,
      sectionSpinning: false,
      classSpinning: false,
      studentSpinning: false,
      teacherSpinning: false,
      loading: false,
      visible: false,
      spinning: false,
      search: null,
      teacherSearch: null,
      dateFormat: 'DD-MM-YYYY',
      studentLeaveRequestId: null,
      comments: null,
      leaveRequestFiles: [],
      fileList: [],
      enrollments: [],
    }
  },
  created() {
    this.searchStudents = debounce(this.searchStudents, 500)
    this.searchTeachers = debounce(this.searchTeachers, 500)
  },
  mounted: function () {
    this.$eventBus.$on('openStudentLeaveRequestFormModal', this.showModal)
  },
  computed: {
    ...mapState(['settings']),
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  methods: {
    moment,
    openAddForm: function() {
      this.$eventBus.$emit('openStudentLeaveRequestFormModal')
    },
    showModal: function(studentLeaveRequestId) {
      this.visible = true
      this.resetData()
      this.form.resetFields()

      this.getTeachers()

      if (studentLeaveRequestId) {
        this.studentLeaveRequestId = studentLeaveRequestId
        this.loading = true
        this.spinning = true
        this.$http.get('/api/student/leave_request/' + studentLeaveRequestId)
          .then(({ data }) => {
            this.selectedTeacher = data.data.assigned_to
            this.comments = data.data.comments
            this.leaveRequestFiles = data.data.files
            this.enrollments = data.data.enrollment_mappings
            this.selectedStudent = data.data.enrollment ? data.data.enrollment.student : null
            const editData = pick({ ...data.data }, ['start_date', 'end_date', 'reason', 'teacher_remark', 'status'])
            editData.start_date = moment(editData.start_date)
            editData.end_date = moment(editData.end_date)
            this.form.setFieldsValue(editData)
            this.spinning = false
            this.loading = false
          })
      } else {
        this.sessionSpinning = true
        this.$http.get('/api/session')
          .then(({ data }) => {
            this.schoolSessions = data.data
            this.selectedSession = find(data.data, ['is_current', 1]).id
            this.sessionSpinning = false
            this.getClasses()
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    resetData() {
      this.data = []
      this.meta = {}
      this.selectedClass = undefined
      this.selectedSection = undefined
      this.selectedStudent = null
      this.selectedTeacher = null
      this.search = null
      this.teacherSearch = null
      this.studentLeaveRequestId = null
    },
    getClasses() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleClassSelect(value) {
      this.selectedSection = undefined
      if (value) {
        this.sectionSpinning = true
        this.getClassSections(value)
      }
    },
    getClassSections(value) {
      this.$http.get(`/api/section/class/${value}`, {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSectionChange (value) {
      if (value) {
        this.selectedSection = value
        this.getStudents()
      } else {
        this.selectedSection = undefined
        this.data = []
      }
    },
    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }
      this.selectedSection = undefined
      this.selectedClass = undefined

      this.getClasses()
      // this.getStudents()
    },
    getTeachers: function(isSearch) {
      this.teacherSpinning = true

      let page = this.teacherCurrent
      if (isSearch) {
        page = 1
        this.teacherCurrent = 1
      }
      this.$http.get('/api/teacher', {
        params: {
          limit: this.teacherPageSize,
          search: this.teacherSearch,
          page: page,
        },
      }).then(({ data }) => {
        this.teachers = data.data
        this.teacherSpinning = false
        this.teachersMeta = data.meta
      })
    },
    searchTeachers: function(e) {
      this.teacherSearch = e.target.value
      this.getTeachers(true)
    },
    getStudents: function(isSearch) {
      // this.loading = true
      this.studentSpinning = true

      let page = this.current
      if (isSearch) {
        page = 1
        this.current = 1
      }

      this.$http.get('/api/student', {
        params: {
          limit: this.pageSize,
          page: page,
          search: this.search,
          class_id: this.selectedClass,
          section_id: this.selectedSection,
          session_id: this.selectedSession,
        },
      }).then(({ data }) => {
        this.studentSpinning = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    searchStudents: function(e) {
      this.search = e.target.value
      this.getStudents(true)
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getStudents()
    },
    onChange(current) {
      this.current = current
      this.getStudents()
    },
    onShowTeachersSizeChange(current, pageSize) {
      this.teacherPageSize = pageSize
      this.teacherCurrent = current
      this.getTeachers()
    },
    teacherOnChange(current) {
      this.teacherCurrent = current
      this.getTeachers()
    },
    handleStudentSelect: function(student) {
      this.selectedStudent = student
    },
    handleTeacherSelect: function(teacher) {
      this.selectedTeacher = teacher
    },
    isStudentSelected: function(student) {
      if (this.selectedStudent) {
        return this.selectedStudent.id === student.id
      }
      return false
    },
    isTeacherSelected: function(teacher) {
      if (this.selectedTeacher) {
        return this.selectedTeacher.id === teacher.id
      }
      return false
    },
    handleSave: function (e) {
      /* let postUrl = this.studentLeaveRequestId
        ? '/api/student/leave_request/update/' + this.studentLeaveRequestId
        : '/api/student/leave_request/' + this.selectedStudent.enrollment[0].id */

      let postUrl = '/api/student/leave_request/update/' + this.studentLeaveRequestId
      this.form.validateFields((err, values) => {
        if (!err) {
          // if (this.selectedStudent) {
          this.loading = true
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to save the leave request`,
            onOk: () => {
              this.$http
                .post(postUrl, {
                  // teacher_id: this.selectedTeacher ? this.selectedTeacher.id : null,
                  start_date: moment(values.start_date).format('YYYY-MM-DD'),
                  end_date: moment(values.end_date).format('YYYY-MM-DD'),
                  reason: values.reason,
                  teacher_remark: values.teacher_remark,
                  status: values.status,
                  assigned_to: this.selectedTeacher ? this.selectedTeacher.id : null,
                  comment: values.comment,
                  files: this.fileList,
                })
                .then(() => {
                  this.$emit('saved')
                  this.loading = false
                  this.visible = false
                  this.form.resetFields()
                  this.resetData()
                  this.$notification['success']({
                    message: 'Successfully saved',
                    description: 'Leave request has been saved successfully!',
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
          /* } else {
            this.$message.error('Student not selected! Please select a student.')
          } */
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
      this.resetData()
    },
  },
}
</script>

<style scoped>
.ant-input-disabled {
  color : #1a252f !important;
}
</style>
